import { render, staticRenderFns } from "./AkademieMain.vue?vue&type=template&id=8aeb75de&scoped=true"
import script from "./AkademieMain.vue?vue&type=script&lang=js"
export * from "./AkademieMain.vue?vue&type=script&lang=js"
import style0 from "./AkademieMain.vue?vue&type=style&index=0&id=8aeb75de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeb75de",
  null
  
)

export default component.exports